import styled from "styled-components";
import { COLORS } from "../../../../../../assets/constants/styles";

export const JSONContainer = styled.pre`
  background-color: ${COLORS.white};
  padding: 12px;
  border-radius: 4px;
  overflow: auto;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  max-height: 400px;
  border: 2px solid ${COLORS.lightGrey};
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const JSONKey = styled.span`
  color: ${COLORS.violet};
  font-weight: 600;
`;

export const JSONString = styled.span`
  color: #41ad74;
`;

export const JSONNumber = styled.span`
  color: #2178bd;
`;

export const JSONBoolean = styled.span`
  color: #f5871f;
`;

export const JSONNull = styled.span`
  color: #808080;
`;

export const JSONIndent = styled.div`
  margin-left: ${(props) => props.level * 20}px;
  padding-left: 10px;
`;

export const JSONObjectContainer = styled.span`
  display: block;
`;

export const JSONArrayContainer = styled.span`
  display: block;
`;

export const JSONLine = styled.div`
  padding: 2px 0;
`;

export const JSONComma = styled.span`
  color: ${COLORS.grey};
`;
